import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import VLogo from "../../../components/design/VLogo";

const methodLabels = {
  freeze_dried: ["Frystorkad", "Freeze-dried"],
  dehydrated: ["Torkad", "Dehydrated"],
};

export default function FarmProcessedProductItem({ item }) {
  const language = useSelector((state) => state.app.language);
  const [failedImage, setFailedImage] = useState("");
  const image = item.image?.[language] || "";
  const name = item.name[language] || item.name[0];
  return <article className="FarmProductCard FarmProcessedCard">
    <Link to={`/farm/products/processed/${encodeURIComponent(item.firebaseId)}`} className="FarmProductCardLink" aria-label={`${language === 0 ? "Upptäck produkten" : "Explore product"}: ${name}`}>
      <span className="FarmProductCardImage">
        {image && failedImage !== image
          ? <img src={image} alt={name} loading="lazy" onError={() => setFailedImage(image)} />
          : <span className="FarmProcessedImageFallback" role="img" aria-label={language === 0 ? "Produktbild saknas" : "Product image unavailable"}><VLogo springAni={{ fill: "#45aa9b" }} /></span>}
      </span>
      <span className="FarmProductCardContent">
        <span className="FarmProcessedMethod">{(methodLabels[item.method] || methodLabels.freeze_dried)[language]}</span>
        <span className="FarmProductCardHeading"><strong>{name}</strong></span>
        {item.subtitle[language] && <span className="FarmProductCardDescription">{item.subtitle[language]}</span>}
        <span className="FarmProductCardAction">{language === 0 ? "Upptäck produkten" : "Explore product"}<ArrowForwardIcon /></span>
      </span>
    </Link>
  </article>;
}
